/* Copyright (c) 2018 Scaper */

export const BECOME_A_SCAPER_PATH = "/become-a-scaper";
